import PolyMap from '../../polyMesh/geometric/model/PolyMap';
import PolyMesh from '../../polyMesh/geometric/model/PolyMesh';

const Skin = {
  schema: {
    boneNodeList: { type: 'NodeList', label: 'Select Bones', plug: 'Bone' },
    optionalRootBone: { type: 'Node', label: 'Optional Root Bone', defaultValue: null, filter: function (n) { return n.isBone(); } },
  },

  update: function (operator, primitive, { node, getWorldTransform }) {
    const skinWorldTransform = getWorldTransform(node.id);

    // Ensure we reference the bone node list, so that the dependency
    // graph gets updated properly.
    const nodeList = operator.boneNodeList;
    const rootBone = operator.optionalRootBone;
    let rootBoneIndex = -1;

    if (nodeList.length === 0) return primitive;

    //get world transforms for each bone
    const boneWorldTransforms = nodeList.map((boneNode) => {
      return getWorldTransform(boneNode);
    });

    //get the index of the root bone
    if (rootBone) {
      for (let i = 0, il = nodeList.length; i < il; i++) {
        let boneNode = nodeList[i];
        if (boneNode == rootBone) {
          rootBoneIndex = i;
          break;
        }
      }
    }

    const polyMesh = primitive.mesh;
    const skinToWorldTransform = skinWorldTransform;

    primitive.mesh = skin(polyMesh, skinToWorldTransform, boneWorldTransforms, rootBoneIndex);
  },
};

function skin(polyMesh, skinToWorldTransform, boneWorldTransforms, rootBoneIndex) {
  if (!polyMesh || !polyMesh.skinning) {
    return polyMesh;
  }

  const skinning = polyMesh.skinning;
  const newValues = skinning.applyTransforms(polyMesh.positions.values, skinToWorldTransform, boneWorldTransforms, rootBoneIndex);

  const newPositions = new PolyMap({
    faceRangeOffsets: polyMesh.faceRangeOffsets,
    faceValueIndices: polyMesh.positions.faceValueIndices,
    values: newValues,
  });

  const resultMesh = new PolyMesh(polyMesh);
  resultMesh.positions = newPositions;

  return resultMesh;
};

export default Skin;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Skin.js